import { createSelector } from "reselect"
import { chain, map, get, isEmpty, some } from "lodash"
import { Creators as AssetAnalyticsCreators } from "../model"
import { getGrouping, getSelectedGroup } from "."
import { getDataMap } from "./data"
import { getColumns } from "./columns"

export const getGroupDropdown = createSelector(
  [getDataMap, getGrouping, getColumns, getSelectedGroup],
  (data, currentGroup, columns, selectedGroup) => {
    if (some([data, currentGroup, columns, selectedGroup], isEmpty)) {
      return null
    }

    const descriptors = chain(columns)
      .filter(({ category }) => isEmpty(category))
      .map(column => ({ ...column, getter: (item) => get(item, column.path) }))
      .value()

    return ({
      columns: [
        { id: "label", label: get(currentGroup, "label"), align: "left", getter: get },
        ...descriptors,
      ],
      items: map(data, (group) => ({
        ...group,
        label: group.name,
      })),
      selectedId: selectedGroup,
      backAction: AssetAnalyticsCreators.hideGroup(),
    })
  },
)
